document.addEventListener("DOMContentLoaded", () => {
  var $RadioItem = $(".ann-radio-item");

  $RadioItem.click(function () {
    var $this = $(this);
    $RadioItem.parents(".ann-list-item").removeClass("active");
    $this.parents(".ann-list-item").addClass("active");
  });

  var $NotifyBtn = $(".radio-btn.notify-btn, .ann-pro-item-btn.notify-btn");

  $NotifyBtn.click(function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'VbvBm9']);
  });

  var $LoadMore = $(".load-more");

  $LoadMore.click(function () {
    var $this = $(this);
    $this.siblings(".ann-product-group").find(".ann-product-item").addClass("active");
    $this.hide();
  });
});
